/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreatedMaintenanceRecordRequest = {
  puid: string;
  vin: string;
  sestCode: CreatedMaintenanceRecordRequest.sestCode;
  replaceOdometer: number;
  replaceDate: string;
  isActive?: boolean;
};
export namespace CreatedMaintenanceRecordRequest {
  export enum sestCode {
    _01 = '01',
    _02 = '02',
    _03 = '03',
    _04 = '04',
    _09 = '09',
    _18 = '18',
    _21 = '21',
  }
}

